(() => {
  // Oranlar yüzde (%). Örn: 2 taksit %6.61 demek.
  const RATES = {
    bonus: { 2: 5.96, 3: 7.83, 4: 9.69, 5: 11.56, 6: 13.43,7:15.30,8:17.17,9:19.04,10:20.91,11:22.78,12:24.65 },
    axess: { 2: 5.96, 3: 7.83, 4: 9.69, 5: 11.56, 6: 13.43,7:15.30,8:17.17,9:19.04,10:20.91,11:22.78,12:24.65 },
    world: { 2: 5.96, 3: 7.83, 4: 9.69, 5: 11.56, 6: 13.43,7:15.30,8:17.17,9:19.04,10:20.91,11:22.78,12:24.65 },
    cardfinans: { 2: 5.96, 3: 7.83, 4: 9.69, 5: 11.56, 6: 13.43,7:15.30,8:17.17,9:19.04,10:20.91,11:22.78,12:24.65 },
    advantage: { 2: 5.96, 3: 7.83, 4: 9.69, 5: 11.56, 6: 13.43,7:15.30,8:17.17,9:19.04,10:20.91,11:22.78,12:24.65 },
    paraf: { 2: 5.96, 3: 7.83, 4: 9.69, 5: 11.56, 6: 13.43,7:15.30,8:17.17,9:19.04,10:20.91,11:22.78,12:24.65 },
    bankkart: { 2: 5.96, 3: 7.83, 4: 9.69, 5: 11.56, 6: 13.43,7:15.30,8:17.17,9:19.04,10:20.91,11:22.78,12:24.65 },
    maximum: { 2: 5.96, 3: 7.83, 4: 9.69, 5: 11.56, 6: 13.43,7:15.30,8:17.17,9:19.04,10:20.91,11:22.78,12:24.65 }
  };

  function moneyFormatter(currency) {
    // TRY için TR formatı; başka para birimi varsa yine düzgün gösterir.
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: currency || 'TRY',
      maximumFractionDigits: 2
    });
  }

  function centsToNumber(cents) {
    const n = Number(cents);
    return Number.isFinite(n) ? n / 100 : 0;
  }

  function calcRows(price, rates, fmt) {
    // Basit model: Toplam = fiyat * (1 + oran/100)
    // Aylık = toplam / taksit
    const terms = Object.keys(rates).map(Number).sort((a,b)=>a-b);
    return terms.map((t) => {
      const ratePct = rates[t];
      const total = price * (1 + ratePct / 100);
      const per = total / t;
      return `
        <tr>
          <td>${t} taksit</td>
          <td>${fmt.format(per)}</td>
          <td>${fmt.format(total)}</td>
        </tr>
      `;
    }).join('');
  }

  function init(root) {
    const body = root.querySelector('#taksit-body');
    const banks = Array.from(root.querySelectorAll('.taksit-bank'));
    const priceCents = root.getAttribute('data-price-cents');
    const currency = root.getAttribute('data-currency') || 'TRY';
    const fmt = moneyFormatter(currency);

    let activeBank = banks.find(b => b.classList.contains('is-active'))?.dataset.bank || banks[0]?.dataset.bank;
    if (!activeBank) return;

    function render() {
      // Ürün varyant fiyatı değişirse Shopify genelde HTML’i günceller; biz de attribute’ten okuyoruz.
      const freshPrice = centsToNumber(root.getAttribute('data-price-cents'));
      const rates = RATES[activeBank];
      if (!rates) {
        body.innerHTML = `<tr><td colspan="3">Bu banka için oran bulunamadı.</td></tr>`;
        return;
      }
      body.innerHTML = calcRows(freshPrice, rates, fmt);
    }

    banks.forEach(btn => {
      btn.addEventListener('click', () => {
        banks.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        activeBank = btn.dataset.bank;
        render();
      });
    });

    // Varyant değişiminde fiyatı yakalamak için basit gözlem:
    const observer = new MutationObserver(() => render());
    observer.observe(root, { attributes: true, attributeFilter: ['data-price-cents'] });

    render();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.taksit-wrap').forEach(init);
  });

  // Shopify tema bazı sayfalarda section'ları ajax yeniler:
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll?.('.taksit-wrap')?.forEach(init);
  });
})();